module.exports = __webpack_public_path__ + "static/media/logo.c840ecd7.png";